import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";
import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import type { paths } from "./generated-api-types";

// Create the base fetch client and React Query client
export const $rawApi = createFetchClient<paths>({ baseUrl: "" });
export const $api = createClient($rawApi);

/**
 * Extract a human-readable message from an API error.
 *
 * openapi-fetch surfaces the raw response body for non-2xx responses, which
 * for FastAPI is `{ detail: string | object }`. Falling back to `err.message`
 * loses that information, so we unwrap `detail` when available.
 */
export function describeError(err: unknown): string {
  if (err && typeof err === "object" && "detail" in err) {
    const d = (err as { detail: unknown }).detail;
    if (typeof d === "string") return d;
    try {
      return JSON.stringify(d);
    } catch {
      return String(d);
    }
  }
  if (err instanceof Error) return err.message;
  return i18n._(msg`An error occurred`);
}
